import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

/**
 * Component to handle legacy hash-based URLs and redirect to clean URLs
 * This ensures backward compatibility when migrating from HashRouter to BrowserRouter
 * and is retained so old responder links in emails and embeds keep working.
 *
 * Preserves query parameters from before the hash (e.g., ?participant=123#/survey)
 * which are used for tracking, UTM parameters, and other metadata.
 */
export const HashRedirect = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const hash = window.location.hash;

		if (hash && hash.startsWith("#/")) {
			const cleanPath = hash.substring(1);
			const search = window.location.search;
			const fullPath = search ? `${cleanPath}${search}` : cleanPath;

			navigate(fullPath, {replace: true});
		}
	}, [navigate]);

	return null;
};
